<template>
  <div id="loan">
    <nav-common></nav-common>
    <div class="loan-content">
      <el-tabs type="border-card" @tab-click="handleClick">
        <el-tab-pane label="本级贷款查询">
          <el-table
            :data="loan.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="贷款渠道"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="agent_name"
              label="代理商"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="money"
              label="额度"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="申请时间"
              align="center"
              width="283">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="getloan"
            :page-size="loan.per_page"
            :current-page="loan.current_page"
            :total="loan.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="二级贷款查询">
          <el-table
            :data="loan.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="贷款渠道"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="agent_name"
              label="代理商"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="money"
              label="额度"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="申请时间"
              align="center"
              width="283">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="loan.per_page"
            @current-change="getloan"
            :current-page="loan.current_page"
            :total="loan.total">
          </el-pagination>
        </el-tab-pane>
        <!-- <el-tab-pane label="三级贷款查询">
          <el-table
            :data="loan.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="贷款渠道"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="agent_name"
              label="代理商"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="money"
              label="额度"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="申请时间"
              align="center"
              width="283">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="loan.per_page"
            @current-change="getloan"
            :current-page="loan.current_page"
            :total="loan.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="四级贷款查询">
          <el-table
            :data="loan.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="贷款渠道"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="agent_name"
              label="代理商"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="money"
              label="额度"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="申请时间"
              align="center"
              width="283">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="loan.per_page"
            @current-change="getloan"
            :current-page="loan.current_page"
            :total="loan.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="五级贷款查询">
          <el-table
            :data="loan.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="贷款渠道"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="agent_name"
              label="代理商"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="money"
              label="额度"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="申请时间"
              align="center"
              width="283">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="loan.per_page"
            @current-change="getloan"
            :current-page="loan.current_page"
            :total="loan.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="六级贷款查询">
          <el-table
            :data="loan.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="贷款渠道"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="agent_name"
              label="代理商"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="money"
              label="额度"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="申请时间"
              align="center"
              width="283">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="loan.per_page"
            @current-change="getloan"
            :current-page="loan.current_page"
            :total="loan.total">
          </el-pagination>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'Loan',
  data () {
    return {
      loan: {},
      params: 'self',
    }
  },
  created() {
    this.getloan(1);
  },
  methods: {
    handleClick(tab, event) {
      var index = parseInt(tab.index);
      var _this = this;
      switch(index) {
        case 0:
          _this.params = 'self';
          _this.getloan(1);
          break;
        case 1:
          _this.params = 'sub';
          _this.getloan(1);
          break;
        case 2:
          _this.params = 'subsub';
          _this.getloan(1);
          break;
        case 3:
          _this.params = 'fourth';
          _this.getloan(1);
          break;
        case 4:
          _this.params = 'fifth';
          _this.getloan(1);
          break;
        case 5:
          _this.params = 'sixth';
          _this.getloan(1);
          break;
        default:
          return;
        };
    },
    getloan(page) {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/loan/' + _this.params + '?page=' + page
      }).then((res) => {
        _this.loan = res.data.data;
        _this.loan.data.forEach(item => {
          if(item.status == 0) {
            item.status = '审核中'
          } else if(item.status == 1) {
            item.status = '通过'
          } else if(item.status == 2) {
            item.status = '未通过'
          } else if(item.status == 3) {
            item.status = '无记录'
          }
        });
      })
    }
  },
  components: {
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .loan-content
    position relative
    margin 20px
    padding 60px 40px 20px 40px
    background #f8f8f8
    box-shadow 3px 3px 3px #f5f5f5 inset
</style>



// WEBPACK FOOTER //
// src/components/loan/loan.vue